import Vue from 'vue';
export default Vue.extend({
    name: 'FieldError',
    render: function (el) {
        return this.hasError ? el('div', {
            class: this.className,
            domProps: {
                innerText: this.message
            },
        }) : null;
    },
    props: {
        bag: {
            type: Object,
            required: true,
        },
        field: {
            type: String,
            required: true
        },
        className: {
            type: String,
            default: 'invalid-feedback'
        }
    },
    computed: {
        hasError: function () {
            return this.bag.has(this.field);
        },
        message: function () {
            return this.bag.first(this.field);
        }
    }
});
